import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';
import { getUser, getHabilitations } from '../variables/constants';
import { lireNavigationEnCache, lireCheminsDeclaresEnCache } from '../services/navigationService';
import { accesAutorise } from '../utils/navigationGuard';
import { memoriserDestination } from '../utils/retourApresConnexion';
import ForceChangePassword from '../pages/security/Forcechangepassword';
import AccesRefuse from './AccesRefuse';

export default function ProtectedRoute({ children, habilitation }) {
  const [user, setUserState] = useState(getUser);
  const location = useLocation();

  // 1. Pas de token → /login, en retenant où l'on allait.
  //    Indispensable aux liens profonds des courriels de mention : ouverts depuis une
  //    boîte aux lettres, ils arrivent dans un onglet neuf, donc sans session, et
  //    l'agent atterrirait sinon sur le tableau de bord au lieu du message qu'on lui
  //    demandait de lire.
  if (!authService.isAuthenticated()) {
    memoriserDestination(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  // 2. Mot de passe à changer → bloquer avec la modale
  if (user?.mustChangePassword) {
    return (
      <>
        <div
          style={{ filter: 'blur(2px)', pointerEvents: 'none', userSelect: 'none' }}
          aria-hidden="true"
        >
          {children}
        </div>
        <ForceChangePassword
          onSuccess={() => {
            setUserState(getUser());
          }}
        />
      </>
    );
  }

  // 3. Habilitation : chemin couvert par le menu de l'utilisateur ?
  //    Pas de redirection vers /login - rediriger un utilisateur deja connecte
  //    vers la connexion est incomprehensible pour lui.
  //    Le catalogue des chemins declares distingue un ecran a part entiere
  //    (/sinistres/affectations-en-attente, qui a sa propre habilitation) d'une route de detail
  //    (/sinistres/<id>, qui n'en a pas) : sans lui, l'entree parente ouvrait
  //    tout son sous-arbre.
  //
  //    Une route peut en outre declarer son habilitation : elle tranche alors
  //    seule, y compris tant que menu et catalogue ne sont pas en cache - fenetre
  //    que le catalogue traverse en laissant passer, pour ne pas bloquer un
  //    rechargement de page.
  if (!accesAutorise({
    menu: lireNavigationEnCache(),
    pathname: location.pathname,
    catalogue: lireCheminsDeclaresEnCache(),
    habilitationRequise: habilitation,
    habilitations: getHabilitations(user),
  })) {
    return <AccesRefuse />;
  }

  // 4. Tout est bon
  return children;
}
